import React from 'react'

function About() {
  return (<>
    <h2 className='text-center'>About</h2>
    <form style={{ margin: 'auto', width: '60%' }}>
      <p>Just me, myself and I, exploring the universe of unknownment. I have a heart of love and an interest of lorem ipsum and mauris neque quam blog. I want to share my world with you. Praesent tincidunt sed tellus ut rutrum. Sed vitae justo condimentum, porta lectus vitae, ultricies congue gravida diam non fringilla. Praesent tincidunt sed tellus ut rutrum. Sed vitae justo condimentum, porta lectus vitae, ultricies congue gravida diam non fringilla.</p>

      <p>
        Do not hesitate to contact me!
      </p>
    </form>

    <div>
    </div>
  </>
  )
}

export { About };
